import React from "react";
import CreateOrUploadCVStep from "../register/RegisterStep/CreateOrUploadCVStep";
import {getAgencyData, getAgencyPosition} from "../../services/DataGetter";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import AgencyRegisterStep from "./AgencyRegisterStep";
import {getStyle} from "../../services/Style";
import renderLoader from "../base/Loader";
import Regions from "../position/Description/Regions";
import EmploymentForm from "../position/Description/EmploymentForm";
import validString, {removeHTMLtags} from "../../services/VariableTools";
import Youtube from "../position/Description/Youtube";
import Skills from "../position/Description/Skills";
import Certificates from "../position/Description/Certificates";
import OtherBenefits from "../position/Description/OtherBenefits";
import Summary from "../position/Description/Summary";
import Footer from "../position/Description/Footer";
import RegisterStepBreadCrumbs from "../register/RegisterStep/RegisterStepBreadCrumbs";
import CompanyDescription from '../position/Description/CompanyDescription';
import {uploadFileToMongo} from "../../services/PostService";
import {sprintf} from "sprintf-js";


export default class AgencyPosition extends React.PureComponent
{
    static propTypes = {
        customerName: PropTypes.string.isRequired,
        language: PropTypes.string.isRequired,
        customerData: PropTypes.objectOf(Promise).isRequired,
        agency: PropTypes.string.isRequired,
        positionId: PropTypes.oneOf([PropTypes.string, PropTypes.number]).isRequired
    };

    constructor(props){
        super(props);

        this.state = {
            loading: true,
            step : 1,
            showModal: false,
            firstName: null,
            lastName: null,
            email: null,
            sex: null,
            phone: null,
			modalText: ''
        };
        this.loadData();
    }

    loadData =() => {
        Promise.all([getAgencyData(this.props.agency), getAgencyPosition(this.props.agency, this.props.positionId), this.props.customerData])
            .then(( [agency, positionData, customerData]) => {
				let requireCv = (positionData['result'] === undefined || positionData.result['portal_data']['requireCv'] === undefined || positionData.result['portal_data']['requireCv'] === 'default') ?
					customerData.result['requiredCV'] :
					positionData.result['portal_data']['requireCv']
				this.setState({
                    loading:false,
                    position: positionData,
                    source: agency.agency.cSource,
                    requireCv: Boolean(requireCv)
				});
            });
    };

    showModal = (modalTitle, modalText) => {
        this.setState({showModal: true, modalTitle: modalTitle, modalText: modalText});
    };

    closeModal = () => {
        this.setState({showModal: false});
    };

    nextStep = () => {
        if (this.state['step'] === 2) {
            window.location.href = window.location.href.substr(0, window.location.href.lastIndexOf('/'));
        }
        this.setState({step: 2, loading: false});
    };

    setCandidateData = (firstName, lastName, sex, email, phone) => {
        this.setState({firstName: firstName, lastName: lastName, sex: sex,  email: email, phone: phone});
    };

	uploadToMongo = (file) => {
		if (!file) {
			return;
		}

		const allowedExtensions =
			/(\.pdf|\.docx|\.doc|\.odt|\.rtf)$/i;

		if (!allowedExtensions.exec(file.name)){
			this.showModal(window.Translator.getSlug('Error', this.props.language), sprintf(window.Translator.getSlug('InvalidFileFormat', this.props.language)));
			return;
		}

		if (file.size > this.maxSize) {
			this.showModal(window.Translator.getSlug('Error', this.props.language), sprintf(window.Translator.getSlug('MaxFileSize%sMbExceeded', this.props.language), this.maxSizeMb));
			return;
		}

		this.setState({loading: true});
		uploadFileToMongo(file, this.props.customerName, this.props.language, this.props.agency)
			.then(response => response.json())
			.then(json => {
				sessionStorage.setItem('cv-file-mongoid', json.mongoId);
				sessionStorage.setItem('cv-file-name', file.name);
				sessionStorage.setItem('cv-file-size', file.size);
				sessionStorage.setItem('cv-uploaded', json.mongoId);
				if (json.hasOwnProperty('dataToLocalStorage') && json.dataToLocalStorage && Object.values(json.dataToLocalStorage).length > 0) {
					this.setCandidateData(
						json.dataToLocalStorage['firstName'],
						json.dataToLocalStorage['lastName'],
						parseInt(json.dataToLocalStorage['sex']),
						json.dataToLocalStorage['email'],
						json.dataToLocalStorage['phone']
					);
				}
				this.nextStep();
				if (!json.success) {
					this.showModal(window.Translator.getSlug('Error', this.props.language), json.hasOwnProperty('reason') ? json.reason : '');
				}
			})
			.catch(error => {
				this.showModal(window.Translator.getSlug('Error', this.props.language), error.toString());
				this.setState({loading: false});
			});
	};

    renderStep = () => {
        let {position, requireCv} = this.state;
        switch (this.state['step']) {
            case 1 :
                if (position.hasOwnProperty('result')) {
                    position = position.result;
                    return (
                        <>
                            <div className="job-title-and-info d-block">
                                <div className="title">
                                    <div className="title-body">
                                        <h4>{position.data.name}</h4>
                                        <div className="info">
                                            <div className={"displayFlex"}>
                                                <Regions regions={position.position_export_region}
                                                         className={"padding-right-5 fa fa-map-marker-alt"}/>
                                            </div>
                                            <div className={"displayFlex"}>
                                                <EmploymentForm employmentForm={position.employment_form}/>
                                            </div>
                                            {position.data.salary_text && position.data.salary_text.length > 0 &&
                                                <div className={"displayFlex"}>
                                                    <span>
                                                        <i className={"darkGray padding-right-5 fa fa-money-bill-alt"}/>
                                                        {removeHTMLtags(position.data.salary_text)}
                                                    </span>
                                                </div>}
                                        </div>
                                    </div>
                                </div>
                                <div className={"row padding-top-15"}>
                                    <div className={"col-12 " + (requireCv ? 'col-md-8' : 'col-md-4')}>
                                        <div className={"row"}>
                                            <CreateOrUploadCVStep
                                                customerName={this.props.customerName}
                                                language={this.props.language}
                                                positionId={this.props.positionId}
                                                nextStep={this.nextStep}
                                                changeCandidateData={this.setCandidateData}
                                                showModal={this.showModal}
                                                requireCv={requireCv}
                                                agency={this.props.agency}
												uploadToMongo={this.uploadToMongo}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="details-information section-padding-30">
                                <div className="row">
                                    <div className="col-xl-7 col-lg-8">
                                        <Youtube source={position.data.youtube}/>
                                        {this.renderDescriptionSection(window.Translator.getSlug('JobDescription', this.props.language), position.data.job_note, 'align-left')}
                                        {this.renderDescriptionSection(window.Translator.getSlug('CandidateRequirements', this.props.language), position.data.personal_requirements, 'bolt')}
                                        {this.renderDescriptionSection(window.Translator.getSlug('OtherRequirements', this.props.language), position.data.other_requirements, 'book')}
                                        {position.data.benefit &&
                                        <div className="other-benifit details-section ">
                                            <h4>
                                                <i className={"padding-right-15 padding-top-15 padding-bottom-15 far fa-thumbs-up"}> </i>
                                                {window.Translator.getSlug('OtherBenefits', this.props.language)}
                                            </h4>
                                            <div dangerouslySetInnerHTML={{__html: position.data.benefit}}/>
                                        </div>}
                                        <Skills
                                            skills={position.skills}
                                            language={this.props.language}
                                        />
                                        <Certificates
                                            certificates={position.certificates}
                                            language={this.props.language}
                                        />
                                        {position.data.personal_prerequisites &&
                                        <div className="other-benifit details-section margin-bottom-30">
                                            <h4>
                                                <i className={"padding-right-15 padding-top-15 padding-bottom-15 fa fa-info"}> </i>
                                                {window.Translator.getSlug('PersonalityRequirements', this.props.language)}
                                            </h4>
                                            <div
                                                dangerouslySetInnerHTML={{__html: position.data.personal_prerequisites}}/>
                                        </div>}
                                        <OtherBenefits
                                            language={this.props.language}
                                            content={position.data.interview}
                                        />
                                    </div>

                                    <div className="col-xl-4 offset-xl-1 col-lg-4">
                                        <div className="information-and-share">
                                            <Summary
                                                data={position.data}
                                                language={this.props.language}
												customerName={this.props.customerName}
												positionId={this.props.positionId}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
								<CompanyDescription
									language={this.props.language}
									companyDescription={position.data.companyDescription}
									companyName={position.data.companyName}
								/>
                                <Footer
                                    language={this.props.language}
                                    customerData={this.props.customerData}
                                    consultant={position.data.user}
                                    customerName={this.props.customerName}
                                />
                            </div>
                        </>
                    );
                } else {
                    return (
                        <>
                            <RegisterStepBreadCrumbs
                                customerName={this.props.customerName}
                                language={this.props.language}
                                positionName={position.hasOwnProperty('result') ? position.result.data.name : position.name}
                                positionId={this.props.positionId}
                                positionListLink={`/${this.props.language}/gate/${this.props.customerName}/agency/${this.props.agency}/add-candidate`}
                                positionLink={`/${this.props.language}/gate/${this.props.customerName}/agency/${this.props.agency}/add-candidate/${this.props.positionId}`}
                            />
                            <div className={"details-information section-padding-30"} >
                                <div className={"row"}>
                                    <CreateOrUploadCVStep
                                        customerName={this.props.customerName}
                                        language={this.props.language}
                                        positionId={this.props.positionId}
                                        nextStep={this.nextStep}
                                        changeCandidateData={this.setCandidateData}
                                        requireCv={requireCv}
                                        showModal={this.showModal}
                                        agency={this.props.agency}
										uploadToMongo={this.uploadToMongo}
                                    />
                                </div>
                            </div>
                        </>
                    );
                }
            case 2:
                return (
                    <>
                        <RegisterStepBreadCrumbs
                            customerName={this.props.customerName}
                            language={this.props.language}
                            positionName={position.hasOwnProperty('result') ? position.result.data.name : position.name}
                            positionId={this.props.positionId}
                            positionListLink={`/${this.props.language}/gate/${this.props.customerName}/agency/${this.props.agency}/add-candidate`}
                            positionLink={`/${this.props.language}/gate/${this.props.customerName}/agency/${this.props.agency}/add-candidate/${this.props.positionId}`}
                        />
                        <AgencyRegisterStep
                            customerName={this.props.customerName}
                            positionId={this.props.positionId}
                            showModal={this.showModal}
                            language={this.props.language}
                            nextStep={this.nextStep}
                            customerData={this.props.customerData}
                            firstName={this.state['firstName']}
                            lastName={this.state['lastName']}
                            sex={this.state['sex']}
                            phone={this.state['phone']}
                            email={this.state['email']}
                            source={this.state['source']}
                            agency={this.props.agency}
                        />
                    </>
                );
            default:
                return null;
        }
    };

    renderDescriptionSection = (title, content, icon) => {
        if (!validString(content)) {
            return null;
        }
        return (
            <div className="responsibilities details-section">
                <h4>
                    <i className={"padding-right-15 padding-top-15 padding-bottom-15 fa fa-" + icon}> </i>
                    {title}
                </h4>
                { content !== undefined && content !== null && <div dangerouslySetInnerHTML={{__html: content}}/>}
            </div>
        );
    };

    render = () => {
        let {showModal, modalTitle, modalText} = this.state;
        return (
            <div className="section-padding-bottom alice-bg flexHeight">
                <div className="alice-bg padding-top-30 section-padding-bottom flexHeight2"
                     style={getStyle(this.props.positionId, 'backgroundColor', this.props.customerName)}>
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <div className="job-listing-details job-detail-position">
                                    <Modal show={showModal} onHide={this.closeModal} animation={false} dialogClassName={'smallDialog'}>
                                        <Modal.Header>
                                            <Modal.Title>{modalTitle}</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>{modalText}</Modal.Body>
                                        <Modal.Footer>
                                            <button onClick={this.closeModal} className={'btn btn-default'}>
                                                {window.Translator.getSlug('Close', this.props.language)}
                                            </button>
                                        </Modal.Footer>
                                    </Modal>
                                    {this.state['loading'] ? renderLoader("jobsLoader") :this.renderStep()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}
